module.exports = __webpack_public_path__ + "img/131.9fb20fbc.png";